if (!customElements.get('video-embed')) {
    class VideoEmbed extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('video');
        this.playBtn = this.querySelector('.js-play-btn');
        this.thumbnail = this.querySelector('.video-thumbnail');
        this.isPlaying = false;
        this.playBtn.addEventListener('click', () => {
          this.video.play();
        })
        this.video.addEventListener('play', () => {
          document.querySelectorAll('video').forEach(video => {
            if (video !== this.video) video.pause();
          });
          this.playBtn.style.display = "none";
          if (this.thumbnail) this.thumbnail.style.display = "none";
          this.isPlaying = true;
        })
        this.video.addEventListener('pause', () => {
          this.playBtn.style.display = "block";
          if (this.thumbnail) this.thumbnail.style.display = "block";
          this.isPlaying = false;
        })
        this.video.addEventListener('click', () => {
          if (this.isPlaying) {
            this.video.pause();
          }
          else {
            this.video.play();
          }
        })

      }
      
    }
    
    customElements.define('video-embed', VideoEmbed);
  }